<template>
  <b-nav-item-dropdown
    right
    no-caret
    class="d-md-down-none"
    style="min-width: 200px; text-align: right;"
  >
    <!--  -->
    <template slot="button-content">
      <i class="fa-regular fa-user fa-2x"></i>
      <!--<img src="static/img/avatars/9.jpg" class="img-avatar" />-->
      <!--<em>{{ fullName }}</em>-->
    </template>

    <b-dropdown-item v-show="isAdmin || isUnilab" @click="goTo('managementtabs')"
      ><i style="color: black" class="fa-solid fa-crop"></i>
      {{ uniTranslation("TRNSL15") }}</b-dropdown-item
    >

    <b-dropdown-item v-show="isAdmin || isUnilab" @click="goTo('languages')"
      ><i style="color: black" class="fa-solid fa-language"></i>
      {{ uniTranslation("TRNSL04") }}</b-dropdown-item
    >
    <b-dropdown-item v-show="bShowEnglishToolTip == false && (isAdmin || isUnilab)" @click="ShowEnglishToolTip"
      ><i style="color: black" class="fa-solid fa-comment"></i>
      {{ uniTranslation("TRNSL13") }}</b-dropdown-item
    >
    <b-dropdown-item v-show="bShowEnglishToolTip == true && (isAdmin || isUnilab)" @click="ShowEnglishToolTip"
      ><i style="color: black" class="fa-solid fa-comment-slash"></i>
      {{ uniTranslation("TRNSL13") }}</b-dropdown-item
    >
    <b-dropdown-item v-show="bShowTranslationsId == false && (isAdmin || isUnilab)" @click="showTranslationsIdToggle"
      ><i style="color: black" class="fa-solid fa-eye"></i>
      {{ uniTranslation("TRNSL67") }}</b-dropdown-item
    >
    <b-dropdown-item v-show="bShowTranslationsId == true && (isAdmin || isUnilab)" @click="showTranslationsIdToggle"
      ><i style="color: black" class="fa-solid fa-eye-slash"></i>
      {{ uniTranslation("TRNSL67") }}</b-dropdown-item
    >
    <b-dropdown-item @click="onClickLogout"
      ><i style="color: black" class="fa-solid fa-right-from-bracket"></i>
      {{ uniTranslation("TRNSL12") }}</b-dropdown-item
    >
  </b-nav-item-dropdown>
</template>
<script>
import Cookies from "js-cookie";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "HeaderDropdown",
  data() {
    return {
      itemsCount: 42
    };
  },
  computed: {
    ...mapGetters("_authModule", ["bShowEnglishToolTip", "bShowTranslationsId","isAdmin","isUnilab"]),
    fullName: function() {
      var that = this;
      var ret = that.loggedUserInfo.fullName;
      return ret;
    }
  },
  mounted: function() {},
  methods: {
    ...mapActions("_authModule", [
      "ShowTranslationsIdAction",
      "ShowEnglishToolTip",
      "isLoggedUserUnilab",
      "isLoggedUserAdmin",
      "loggedUserInfo"
    ]),
    showTranslationsIdToggle(e) {
      e.preventDefault();
      this.ShowTranslationsIdAction();
    },
    showEnglishToolTip(e) {
      e.preventDefault();
      this.ShowEnglishToolTip();
    },
    onClickLogout() {
      Cookies.remove("loginToken");
      this.$router.push("/login").catch(()=>{});
    },
    goTo(comp) {
      this.$router.push("/" + comp).catch(()=>{});
    }
  }
};
</script>
